import charts from '../../charts.js';

const EMAs = [ 5, 8, 12, 20, 26, 50, 200 ];
const SMAs = [ 5, 8, 20, 21, 25, 50, 100, 200 ];

const colours = [
	charts.colours.red,
	charts.colours.orange,
	charts.colours.blue,
	charts.colours.purple,
	charts.colours.green,
	charts.colours.navy,
	charts.colours.lightgrey,
	charts.colours.yellow,
	charts.colours.black,
];

let nextColourIndex = 0;

function nextColour() {
	const colour = colours[ nextColourIndex ];

	nextColourIndex ++;

	if (nextColourIndex === colours.length) {
		nextColourIndex = 0;
	}

	return colour;
}

const overlays = [
	... (SMAs.map(days => ({
		name: `SMA${days}`,
	}))),

	... (EMAs.map(days => ({
		name: `EMA${days}`,
	}))),

	{
		name: 'BB25_lower',
		extra: {
			stroke: charts.colours.blue,
		},
	},
	{
		name: 'BB25',
		extra: {
			stroke: charts.colours.blue,
			strokeDasharray: charts.values.strokeDash,
		},
	},
	{
		name: 'BB25_upper',
		extra: {
			openValueYField: 'BB25_lower',
			stroke: charts.colours.blue,
			fill: charts.colours.blue,
			fillOpacity: 0,
			fills: {
				fillOpacity: 0.2,
				visible: true,
			},
		},
	},

	{
		name: 'BB100_lower',
		extra: {
			stroke: charts.colours.blue,
		},
	},
	{
		name: 'BB100',
		extra: {
			stroke: charts.colours.blue,
			strokeDasharray: charts.values.strokeDash,
		},
	},
	{
		name: 'BB100_upper',
		extra: {
			openValueYField: 'BB100_lower',
			stroke: charts.colours.blue,
			fill: charts.colours.blue,
			fillOpacity: 0,
			fills: {
				fillOpacity: 0.2,
				visible: true,
			},
		},
	},

	{
		name: 'Ichimoku_SpanA',
		extra: {
			stroke: charts.colours.green,
			visibleInLegend: false,
		},
	},
	{
		name: 'Ichimoku_SpanB',
		extra: {
			stroke: charts.colours.red,
			openValueYField: 'Ichimoku_SpanA',
			visibleInLegend: false,
			fills: {
				templateField: 'IchimokuSettings',
				fillOpacity: 0.2,
				visible: true,
			},
		},
	},

	{
		name: 'Keltner_lower',
		extra: {
			stroke: charts.colours.blue,
			visibleInLegend: false,
		},
	},
	{
		name: 'Keltner',
		extra: {
			stroke: charts.colours.blue,
			strokeDasharray: charts.values.strokeDash,
		},
	},
	{
		name: 'Keltner_upper',
		extra: {
			stroke: charts.colours.blue,
			visibleInLegend: false,
			openValueYField: 'Keltner_lower',
			fill: charts.colours.blue,
			fillOpacity: 0,
			fills: {
				fillOpacity: 0.2,
				visible: true,
			},
		},
	},


];

const trendLines = [
	{
		name: 'trendline_resistance',
		name: 'trendline_resistance',
		balloonFunction: function(d) {
			return `
				<p>
					<strong>Trading Channel</strong>
				</p>
				<p>Resistance: $${charts.formatNumber(parseInt(d.resistance))}</p>
				<p>Support: $${charts.formatNumber(parseInt(d.support))}</p>
				<p>Volume: $${charts.formatNumber(parseInt(d.volume))}</p>
				`;
		},
		valueYField: 'resistance',
		stroke: charts.colours.red,
		hidden: false,
		showBalloon: true,
		visibleInLegend: false,
	},
	{
		name: 'trendline_support',
		name: 'trendline_support',
		valueYField: 'support',
		stroke: charts.colours.green,
		hidden: false,
		showBalloon: false,
		visibleInLegend: false,
		connect: true,
	}
];



let patterns = [

	{
		name: 'consolidations',
		balloonFunction: function(params) {
			if(params==undefined){
				return "";
			}

			return `
			<p><strong>Consolidations</strong></p>
			<p>
				<strong>Stage: </strong>${params.baseStage}(${params.baseNumber})<br>
				<strong>Pivot: </strong>${params.pivot??'--'}<br>
				<strong>Depth: </strong>${Math.round(100*params.properties.filter(v=>v.Key=="BaseDepth").pop().Value)}%<br>
				<strong>Length: </strong>${params.baseLength} days<br>
			</p>
			`;
		},
		extra: {
			stroke: charts.colours.green,
			lineWidth:0,
			visibleInLegend: false,
		}
	},
	{
		name: 'cupWithHandles',
		balloonFunction: function(params) {
			if(params==undefined || !params.cupWithHandles_additional){
				return "";
			}
			//console.log("BALOON",params);
			params = params.cupWithHandles_additional;
			let handle = params.properties.filter(v=>v.Key=="HandleDepth").pop().Value
			/*
			return `
			<p style='text-align:center'><strong>Cup${handle>0?' with Handle':''}</strong></p>
			<p>
				<strong>Stage: </strong>${params.baseStage}(${params.baseNumber})<br>
				<strong>Pivot: </strong>$${Math.round(params.pivot*100)/100}<br>
				<strong>Depth: </strong>${Math.round(100*params.properties.filter(v=>v.Key=="BaseDepth").pop().Value)}%<br>
				<strong>Length: </strong>${params.baseLength} days<br>
				${handle>0? `<strong>Handle: </strong>${Math.round(100*handle)}%<br>`:``}
			</p>
			`;
			*/
			return `
			<p style='text-align:center'><strong>Cup${handle>0?' with Handle':''}</strong></p>
			<p>
				<strong>Pivot: </strong>$${Math.round(params.pivot*100)/100}<br>
				<strong>Depth: </strong>${Math.round(100*params.properties.filter(v=>v.Key=="BaseDepth").pop().Value)}%<br>
				<strong>Length: </strong>${params.baseLength} days<br>
				${handle>0? `<strong>Handle: </strong>${Math.round(100*handle)}%<br>`:``}
			</p>
			`;
		},
		extra: {
			stroke: charts.colours.red,
			lineWidth:0,
			visibleInLegend: false,
		}
	},
	{
		name: 'doubleBottoms',
		balloonFunction: function(params) {
			if(params==undefined){
				return "";
			}

			return `
			<p><strong>Double Bottom</strong></p>
			<p>
				<strong>Stage: </strong>${params.baseStage}(${params.baseNumber})<br>
				<strong>Pivot: </strong>${params.pivot??'--'}<br>
				<strong>Depth: </strong>${Math.round(100*params.properties.filter(v=>v.Key=="BaseDepth").pop().Value)}%<br>
				<strong>Length: </strong>${params.baseLength} days<br>
			</p>
			`;
		},
		extra: {
			stroke: charts.colours.blue,
			lineWidth:0,
			visibleInLegend: false,
		}
	},
	{
		name: 'flatBases',
		balloonFunction: function(params) {
			if(params==undefined){
				return "";
			}

			return `
			<p><strong>Flat Base</strong></p>
			<p>
				<strong>Stage: </strong>${params.baseStage}(${params.baseNumber})<br>
				<strong>Pivot: </strong>${params.pivot??'--'}<br>
				<strong>Depth: </strong>${Math.round(100*params.properties.filter(v=>v.Key=="BaseDepth").pop().Value)}%<br>
				<strong>Length: </strong>${params.baseLength} days<br>
			</p>
			`;
		},
		extra: {
			stroke: charts.colours.navy,
			lineWidth:0,
			visibleInLegend: false,
		}
	},
	{
		name: 'iPOs',
		balloonFunction: function(params) {
			if(params==undefined){
				return "";
			}

			return `
			<p><strong>iPO</strong></p>
			<p>
				<strong>Stage: </strong>${params.baseStage}(${params.baseNumber})<br>
				<strong>Pivot: </strong>${params.pivot??'--'}<br>
				<strong>Depth: </strong>${Math.round(100*params.properties.filter(v=>v.Key=="BaseDepth").pop().Value)}%<br>
				<strong>Length: </strong>${params.baseLength} days<br>
			</p>
			`;
		},
		extra: {
			stroke: charts.colours.orange,
			lineWidth:0,
			visibleInLegend: false,
		}
	},
]

let patternsMap = [];

patterns.map(v=>{
	patternsMap.push({
			name: v.name,
			extra: {
				stroke: v.extra.stroke,
				openValueYField: v.name,
				fillAlphas: 0.2,
				visibleInLegend: true,
				gapPeriod: 5,
				connect: false,
				showBalloon:true,
				balloonFunction: v.balloonFunction,
			},
		})
	/*
	patterns.push({
			name: v.name+'_upper',
			extra: {
				stroke: v.extra.stroke,
				visibleInLegend: false,
				gapPeriod: 4,
				connect: false,
			},
		})
	*/
})

const graphs = {
	// OHLC so they can display on the legend
	open: {
		name: 'open',
		title: 'Open',
		valueYField: 'open',
		type: 'lineSeries',
		strokeOpacity: 0,
	},

	high: {
		name: 'high',
		title: 'High',
		valueYField: 'high',
		type: 'lineSeries',
		strokeOpacity: 0,
	},

	low: {
		name: 'low',
		title: 'Low',
		valueYField: 'low',
		type: 'lineSeries',
		strokeOpacity: 0,
	},

	close: {
		name: 'close',
		title: 'Close',
		valueYField: 'close',
		type: 'lineSeries',
		strokeOpacity: 0,
	},

	// candlesticks
	candlesticks: {
		name: 'candlesticks',
		type: 'candlestickSeries',
		openValueYField: 'open',
		highValueYField: 'high',
		lowValueYField: 'low',
		valueYField: 'close',
		legendLabelText: 'Price',
		visibleInLegend: false,
	},

	// line chart
	line: {
		name: 'line',
		type: 'lineSeries',
		valueYField: 'close',
		legendLabelText: 'Price',
		visibleInLegend: false,
	},

	// scatter chart
	scatter: {
		name: 'scatter',
		type: 'dotSeries',
		valueYField: 'close',
		legendLabelText: 'Price',
		visibleInLegend: false,
	},
};

for (const { name, extra } of overlays) {
	graphs[ name ] = {
		name,
		type: 'lineSeries',
		valueYField: name,
		legendLabelText: name,
		... extra,
	};
}

// for (const { name, extra } of patternsMap) {
// 	graphs[ name ] = charts.lineGraph({
// 		name,
// 		valueYField: name,
// 		legendLabelText: name,
// 		... extra,
// 	})
// }
//
// for (const trendLine of trendLines) {
// 	graphs[ trendLine.name ] = charts.lineGraph(trendLine);
// }

export default graphs;

export {
	nextColour,
	colours,
}
